'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const Formatters=require('../../../../dist-es6/client/formatters');let

FatigueThresholdLineDirective=function(_BaseControllerBacked){_inherits(FatigueThresholdLineDirective,_BaseControllerBacked);function FatigueThresholdLineDirective(){_classCallCheck(this,FatigueThresholdLineDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(FatigueThresholdLineDirective,[{key:'objectBindings',get:function()
{
return['plotArea','verticalAxis','horizontalAxis','fatigueThreshold'];
}},{key:'textBindings',get:function()

{
return[];
}},{key:'controller',get:function()

{
return FatigueThresholdLineDirectiveController;
}}]);return FatigueThresholdLineDirective}(BaseControllerBackedDirective);let


FatigueThresholdLineDirectiveController=function(){_createClass(FatigueThresholdLineDirectiveController,null,[{key:'$inject',get:function()
{return['$scope','$element','$timeout','$window']}}]);

function FatigueThresholdLineDirectiveController($scope,$element,$timeout,$window){var _this2=this;_classCallCheck(this,FatigueThresholdLineDirectiveController);
$scope.$watch('controller.plotArea',function(){
if(_.exists(_this2.plotArea)){
_this2.plotArea.registerPlotter(_this2);
}
});
}FatigueThresholdLineDirectiveController.prototype.









redraw=function redraw(){
if(!this._scalesValid){
return;
}

let fatigueThresholdGroup=d3.select(this.plotArea.svgElement).append('g').attr({
class:'fatigue-threshold',
transform:`translate(${this.plotArea.dimensions.width}, 0)`});


fatigueThresholdGroup.selectAll('line').
data([{yPos:this.verticalAxis.scale(this.fatigueThreshold)}]).
enter().
append(`line`).
attr({
x1:-this.plotArea.graphAreaDimensions.width,
x2:0,
y1:function(pointInfo){return pointInfo.yPos},
y2:function(pointInfo){return pointInfo.yPos},
class:this.class}).

style({
"stroke-width":1,
stroke:'#6A8187'});

};_createClass(FatigueThresholdLineDirectiveController,[{key:'_scalesValid',get:function(){return _.exists(this.horizontalAxis)&&_.exists(this.horizontalAxis.scale)&&_.exists(this.verticalAxis)&&_.exists(this.verticalAxis.scale)}}]);return FatigueThresholdLineDirectiveController}();


module.exports=FatigueThresholdLineDirective;
//# sourceMappingURL=fatigueThresholdLineDirective.js.map
